import { set } from 'lodash';
import Mustache from 'mustache';
import proxyData from 'mustache-validator';
import { getConvenienceVariables } from '../convenienceVariables';
export function renderSetUserState(setUserState, contentData) {
    const { variable, value } = setUserState.elements;
    const path = variable.value;
    const parsedValue = renderMustacheAndParseAsJSON(value.value, contentData);
    const data = {};
    set(data, path, parsedValue);
    return data;
}
/**
 * Transforms user-entered values from kentico into the usable data they represent.
 *
 * Values are first evaluated for mustache templating, and then the resulting string is parsed as
 * JSON.
 */
export function renderMustacheAndParseAsJSON(value, contentData) {
    const templateResult = renderMustacheTemplate({
        template: value,
        data: contentData,
    });
    return JSON.parse(templateResult);
}
export function renderMustacheTemplate({ template, data, handleError, }) {
    let variables = getConvenienceVariables(data);
    if (handleError) {
        Object.entries(variables)
            .filter(([key, value]) => template.includes(key) && value === null)
            .map(([key]) => `Reference to a variable that is currently null: {{${key}}}`)
            .forEach(handleError);
        variables = proxyData(variables, {
            handleError: (invalidPropertyPathSegments) => handleError(`Reference to a variable that is not defined: ${invalidPropertyPathSegments.join('.')}`),
        });
    }
    return Mustache.render(template, variables);
}
//# sourceMappingURL=content.js.map